import { cx } from '../lib/cx'

/**
 * Regla horizontal. Existe como componente y no como `border-t` suelto para que
 * el aire alrededor de una separación sea el mismo en las seis pantallas.
 */
export interface RuleProps {
  /** Aire debajo de la regla. `none` la deja pegada a lo que sigue. */
  spacing?: 'none' | 'sm' | 'md'
  /** Punteada: separa una nota al pie del contenido, no dos bloques iguales. */
  punteada?: boolean
  className?: string
}

const SPACING: Record<NonNullable<RuleProps['spacing']>, string> = {
  none: '',
  sm: 'mb-4',
  md: 'mb-6',
}

export function Rule({ spacing = 'sm', punteada, className }: RuleProps) {
  return (
    <hr
      data-testid="rule"
      className={cx(
        'border-0 border-t',
        punteada === true ? 'border-dashed border-n300' : 'border-border',
        SPACING[spacing],
        className,
      )}
    />
  )
}
